import { SecurityDetails } from 'src/app/modules/portfolio/models/security-details';
import { SecurityByIdResponseWithNestedObjectsAuditable } from '../../../../web-api-client';
import { mapEntityFromResponseNested } from '../../../admin/mappers/entity/map-entity-from-response-nested';
import { mapInvestmentJurisdictionFromResponse } from '../../../admin/mappers/investment-jurisdiction/map-investment-jurisdiction-from-response';
import { mapSecurityTypeFromResponse } from '../../../admin/mappers/security-type/map-security-type-from-response';
import { mapTransactionTypeFromResponse } from '../../../admin/mappers/transaction-type/map-transaction-type-from-response';
import { mapTaxResultFromResponse } from './map-tax-result-from-response';

export const mapSecurityDetailsFromResponse = (
  security: SecurityByIdResponseWithNestedObjectsAuditable
): SecurityDetails => {
  return new SecurityDetails({
    securityId: security.securityId,
    entity: mapEntityFromResponseNested(security.entity!),
    clientId: security.entity?.client?.clientId,
    generalRateEntityTypeId: security.generalRateEntityTypeId,
    generalRateEntityTypeName: security.generalRateEntityType?.name,
    name: security.name,
    isinCusip: security.isinCusip,
    securityType: mapSecurityTypeFromResponse(security.securityType!),
    investmentJurisdiction: mapInvestmentJurisdictionFromResponse(
      security.investmentJurisdiction!
    ),
    acquisitionDate: security.acquisitionDate,
    dispositionDate: security.dispositionDate,
    transactionType: mapTransactionTypeFromResponse(security.transactionType!),
    taxResults: mapTaxResultFromResponse(security.securityTaxResultItems!),
    statusId: security.securityStatus?.securityStatusId,
    questions: security.securityQuestionAnswers,
    created: security.created,
    modified: security.modified,
    clientName: security.entity?.client?.name,
    comments: security.comment,
  });
};
